var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionOrdering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.71 8.28997L8.00004 3.58997L2.29004 9.28997L3.71004 10.71L7.00004 7.40997V19H9.00004V7.40997L11.29 9.70997L12.71 8.28997Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.29 13.29L17 16.59V5H15V16.59L12.71 14.29L11.29 15.71L16 20.41L21.71 14.71L20.29 13.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionOrdering);
export default __webpack_public_path__ + "static/media/icon-question-ordering.527fc92461c8d1b065e108d00d00eccd.svg";
export { ForwardRef as ReactComponent };